export default __webpack_public_path__ + "static/media/it_8.81fac4b1.mp3";